import React from "react"
import clsx from "clsx"
import UserBuilderErrors from "../UserBuilderErrors"
import AuthenticationStatusViewer from "../../AuthenticationStatusViewer/AuthenticationStatusViewer";
import Switch from "../../Switch/Switch"

export default class UserBuilderGeneral extends React.Component {

  constructor(props) {
    super(props);
    this.parseInputName = this.parseInputName.bind(this);

  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'general',
      'tab-pane': true
    });

    return (
      <div className={tabClasses} id="general">

        {this.renderErrors()}

        {(this.props.owner) && !this.props.modifying_self ? <div className="alert alert-warning text-center"><strong>{I18n.t('the_owner_user_cannot_be_modified')}</strong></div> : null}

        <div className="container">
          {this.renderGeneralForm()}
        </div>

      </div>
    );
  }

  renderErrors() {
    var errors = UserBuilderErrors.general(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderGeneralForm() {
    return (
    <div>
      <div className="row">

        <div className="col-sm-6">
          <div className="form-group">
            <label>{`${I18n.t('first_name')}*`}</label>
            {this.props.read_only || (this.props.owner && !this.props.modifying_self) ? <div>{this.props.first_name}</div> : <input type="text" className={this.renderFieldClasses('first_name')} autoComplete="new-password" value={this.props.first_name || ''} onChange={this.props.onChangeFirstName} />}
          </div>
          {this.renderFieldErrors('first_name')}
        </div>

        <div className="col-sm-6">
          <div className="form-group">
            <label>{`${I18n.t('last_name')}*`}</label>
            {this.props.read_only || (this.props.owner && !this.props.modifying_self) ? <div>{this.props.last_name}</div> : <input type="text" className={this.renderFieldClasses('last_name')} autoComplete="new-password" value={this.props.last_name || ''} onChange={this.props.onChangeLastName} />}
          </div>
          {this.renderFieldErrors('last_name')}
        </div>

      </div>

      <div className="row">

        <div className="col-sm-6">
          <div className="form-group">
            <label>{`${I18n.t('email')}*`}</label>
            {this.props.read_only || (this.props.owner && !this.props.modifying_self) ? <div>{this.props.email}</div> : <input type="text" className={this.renderFieldClasses('email')} autoComplete="new-password" value={this.props.email || ''} onChange={this.props.onChangeEmail} />}
          </div>
          {this.renderFieldErrors('email')}
        </div>

        <div className="col-sm-6">
          <div className="form-group">
            <label>{`${I18n.t('mobile_number')}`}</label>
            {this.props.read_only || (this.props.owner && !this.props.modifying_self) ? <div>{this.props.formatted_phone ? this.props.formatted_phone : I18n.t('none')}</div> : <input type="text" className={this.renderFieldClasses('mobile_number')} autoComplete="new-password" value={this.props.formatted_phone || ''} onChange={this.props.onChangeMobileNumber} />}
          </div>
          {this.renderFieldErrors('mobile_number')}
        </div>

      </div>

      <div className="row">

        <div className="col-sm-3">
          <div className="form-group">
            <label>{I18n.t('status')}</label>
            <br />
            {
              this.props.read_only || (this.props.owner && !this.props.modifying_self) 
              ? 
              <div style={{ textTransform: 'capitalize' }}>{this.props.status}</div> 
              : 
              (
              !this.props.invitation_accepted_at
              ?
              <div>{I18n.t('inactive')}</div>
              :
              <select name="user[status]" value={this.props.invitation_accepted_at && this.props.status ? this.props.status : 'inactive'} onChange={this.props.onChangeStatus} className={this.renderFieldClasses('status')}>
                <option value="active">{I18n.t('active')}</option>
                <option value="inactive">{I18n.t('inactive')}</option>
              </select>
              )
            }
          </div>
          {this.props.id ? <AuthenticationStatusViewer {...this.props} /> : null}
        </div>
        <div className="col-sm-3"></div>
        <div className="col-sm-3">
          <div className="form-group">
            <label>{I18n.t('two_factor')}</label>
            <br />
              <Switch
                onText="yes"
                switchId="two_factor"
                offText="no"
                name="two_factor"
                onChange={this.props.onChangeTwoFactor}
                value={this.props.two_factor}
              />
          </div>
        </div>
      </div>
    </div>);
  }

  parseInputName(name) {
    return name.match(/user\[(.*)\]/)[1];
  }

  renderFieldErrors(field) {
    //console.log('renderFieldErrors', field, this.props.errors, this.props.errors[field]);
    if (this.props.errors && this.props.errors[field]) {
      var errors = this.props.errors[field]

      errors = <li ><b>&#x2022;</b> {errors[0]}</li>;

      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field, classname) {

    var classname = classname || 'form-control';
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }

};
